import Model from 'src/app/core/models/model';

export default class TransactionTypeModel extends Model {
  transaction_type: string;
  description?: string;

  constructor() {
    super();
  }
}
